<template>
    <div :style="{ border: noneBorder ? '' : '1px solid #f5f5f5' }" style="font-weight: 500; padding-bottom: 10px;">
        <div style="display: flex; justify-content: space-between;">
            <div @click="() => { $GlobalStore.closeLastModal() }" style="padding: 20px; width: 60px;">
                <img style="width: 10px;" :src="require('@/assets/img/back_btn_black_new.png')" alt="">
            </div>
            <div @click="showSetting" v-if="isMoney" style="padding: 20px;">
                <img style="width: 17px;" :src="require('@/assets/img/join_setting.png')" alt="">
            </div>
            <!--<div v-else style="padding: 20px;">-->
                <!--<img style="width: 17px;" :src="require('@/assets/img/alarm_new.png')" alt="">-->
            <!--</div>-->
        </div>
        <div style="margin: 0 20px; display: flex; justify-content: space-between; align-items: center;">
            <div style="font-size: 26px;">{{ title }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SoccerHowClassHeader',
    props: {
        title: {
            type: String,
            default: ''
        },
        noneBorder: {
            type: Boolean,
            default: false
        },
        isMoney: {
            type: Boolean,
            default: false
        },
        showSetting: {
            type: Function,
            default: () => { }
        },
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}
</style>